<template>
  <div v-if="authenticatedUser">
    <b-container>

       <!-- Successful recipe share modal -->
      <b-modal id="modal-1" title="Success"
  ok-only >
    <p class="my-2">This Group has been successfully updated!</p>
  </b-modal>

      <div class="mt-5 pl-3 pr-3 pb-3 bg-white">
        <b-row class="pl-3 pr-3 pt-4">
          <h3 class="text-left">Update this group</h3>
        </b-row>
        <hr>
        <b-row>
          <b-col cols-6 class="my-container">
            <b-form>
              <b-form-group><label id="input-group-1__BV_label_" for="input-1" class="d-block text-left text-bold">Group
                name <span class="text-danger">*</span></label>
                <b-form-input id="input-1" v-model="EF.name"></b-form-input>
              </b-form-group>
              <b-alert dismissible style="width: 100%" v-model="emptyNameAlert" variant="danger">
                This name is invalid!
              </b-alert>
              <b-alert dismissible style="width: 100%" v-model="GroupExistsAlert" variant="danger">
                You are not allowd to use this name. This name is used by another Group!
              </b-alert>

 <!--             <b-form-group><label id="input-group-1__BV_label_" for="input-1" class="d-block text-left text-bold">Lock id</label>
                <b-form-input id="input-1" v-model="EF.lockId"></b-form-input>
              </b-form-group> -->
              <b-alert dismissible style="width: 100%" v-model="emptyLockIdAlert" variant="danger">
                This Lock Id is invalid!
              </b-alert>

            </b-form>
          </b-col>
          <b-col cols-6>
            <b-form>

              <b-container>
                <b-row>
                  <b-container class="my-container text-left">
                    <label>Do you want the group to be public readable?</label>
                    <b-form-checkbox
                      checked-value="true"
                      unchecked-value="false"
                      v-model="EF.publicReadable">
                    Yes, I do
                    </b-form-checkbox>
<!--                    </br>-->
<!--                    <label>Need for group consent?</label>-->
<!--                    <b-form-checkbox-->
<!--                      checked-value="true"-->
<!--                      unchecked-value="false"-->
<!--                      v-model="EF.needGroupConsent">-->
<!--                    Yes, there must be-->
<!--                    </b-form-checkbox>-->
<!--                    </br>-->
<!--                     <label>Need for member consent?</label>-->
<!--                    <b-form-checkbox-->
<!--                      checked-value="true"-->
<!--                      unchecked-value="false"-->
<!--                      v-model="EF.needMemberConsent">-->
<!--                    Yes, there must be-->
<!--                    </b-form-checkbox>-->

                  </b-container>
                </b-row>
              </b-container>
            </b-form>
          </b-col>
        </b-row>
        <br>
        <hr>
        <b-row class="p-3 mb-4">
          <div class="float-right">
            <router-link :to="{name: 'groups' }">
              <b-button class="link">Cancel</b-button>
            </router-link>
            <button 
            @click="SendUserDataToAPI"
            class="btn bg-orange" style="margin: 0" type="button">
              Submit
            </button>
          </div>
        </b-row>
      </div>
    </b-container>
  </div>
  <div v-else>
    <section class="pb-lg-5 pt-lg-5">
      <b-jumbotron bg-variant="white">
        <template v-slot:header>You do not have access to this page.</template>
        <h3>
          <p>Please login first.</p>
        </h3>
        <h4>
          <router-link :to="{name: 'home'}">Home page</router-link>
          |
          <router-link :to="{name: 'login'}">Login</router-link>
        </h4>
      </b-jumbotron>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {

      emptyNameAlert: false,
      emptyLockIdAlert: false,
      GroupExistsAlert: false,
      userID: '',
      EF: {name: '',
        lockId: '',
        publicReadable: false,
        needGroupConsent: false,
        needMemberConsent: false

      }
    }
  },
  beforeCreate: function () {
    axios.get('/group/' + this.$route.params.id,
      { withCredentials: true })
      .then(response => {
        this.EF.name = response.data.name
        this.EF.lockId = response.data.lockId
        this.EF.publicReadable = response.data.publicReadable
        // this.EF.needMemberConsent = response.data.needMemberConsent
      })
  },

  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])

  },
  methods: {
    SendUserDataToAPI () {
      if (this.EF.name === '' || this.EF.name === null || this.EF.name === undefined) {
        this.emptyNameAlert = true
      } else {
        this.emptyNameAlert = false

        //    if (this.EF.lockId === '' || this.EF.lockId === null || this.EF.lockId === undefined) {
        //    this.emptyLockIdAlert = true
        //     } else {
        //     this.emptyLockIdAlert = false

        const headers = {
          'Content-Type': 'application/json'
        }

        var InputGroupData = {

          'name': this.EF.name,
          'needGroupConsent': this.EF.needGroupConsent,
          'needMemberConsent': this.EF.needMemberConsent,
          'publicReadable': this.EF.publicReadable
        }

        console.log(InputGroupData)


        axios.post('/group/' + this.$route.params.id, InputGroupData, {
        withCredentials: true       
      }  )
          .then(response => {     
                      
            console.log(response)
            this.$router.push({ name: 'groups' }) 

          })
          .catch((error) => {
            console.log(error)
            this.GroupExistsAlert = true
          })
      }
    }
  }

}
// }

</script>

<style scoped>
  .label-align-left {
    float: left
  }

  .textareaDescription {
    height: 210px
  }

  .inputTypeWidth {
    width: 460px
  }
</style>



// WEBPACK FOOTER //
// src/views/GroupEdit.vue